var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionAssetList", {
        attrs: {
          shouldShowSearch: true,
          title: "Equipment",
          toolbarActions: [
            {
              text: "Equipment",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewAssetClicked",
            },
            {
              text: "Activity",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewActivityClicked",
              isDisabledFunc: () => {
                return _vm.selectedAssets && !_vm.selectedAssets.length
              },
            },
            {
              text: "Filter",
              icon: "filter_list",
              iconColor: "accent",
              emitEvent: "onShowFilterClicked",
            },
            {
              text: "Export",
              icon: "print",
              iconColor: "accent",
              emitEvent: "onExportClicked",
            },
          ],
          currentPage: _vm.currentPage,
          numberOfPages: _vm.numberOfPages,
          assetList: _vm.assetList,
          modelList: _vm.modelList,
          manufacturerList: _vm.manufacturerList,
          categoryList: _vm.categoryList,
          activityTypeList: _vm.activityTypeList,
          assetStatusList: _vm.assetStatusList,
          locationList: _vm.locationList,
          clientList: _vm.clientList,
          userList: _vm.userList,
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewAssetClicked: function ($event) {
            _vm.showDialogFormAssetAdd = true
          },
          onAddNewActivityClicked: function ($event) {
            _vm.showDialogFormActivityAdd = true
          },
          onShowFilterClicked: function ($event) {
            _vm.showDialogFormAssetFilter = true
          },
          onClickViewEquipment: (val) =>
            _vm.$emit("onClickViewEquipmentFromAssetList", {
              ...val,
              breadCrumbTitle: "Equipment",
            }),
          onShouldSearch: (val) => [
            (_vm.currentPage = 1),
            _vm.onShouldSearch(val),
          ],
          onClickPageChange: (val) => [
            (_vm.currentPage = val),
            _vm.fetchAssetList(),
          ],
          onExportClicked: _vm.onExportClicked,
        },
        scopedSlots: _vm._u(
          [
            (_vm.selectedAssets && _vm.selectedAssets.length) ||
            (_vm.filters &&
              ((_vm.filters.statusIds && _vm.filters.statusIds.length) ||
                (_vm.filters.activityTypeIds &&
                  _vm.filters.activityTypeIds.length) ||
                (_vm.filters.modelIds && _vm.filters.modelIds.length) ||
                (_vm.filters.categoryIds && _vm.filters.categoryIds.length) ||
                (_vm.filters.locationIds && _vm.filters.locationIds.length) ||
                (_vm.filters.ownerIds && _vm.filters.ownerIds.length) ||
                (_vm.filters.manufacturerIds &&
                  _vm.filters.manufacturerIds.length)))
              ? {
                  key: "toolbarExtension",
                  fn: function () {
                    return [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _vm.selectedAssets && _vm.selectedAssets.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Selected (" +
                                        _vm._s(_vm.selectedAssets.length) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.selectedAssets, function (asset) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: asset.id,
                                        attrs: {
                                          close: "",
                                          disabled: _vm.isLoading,
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.selectedAssets.splice(
                                              _vm.selectedAssets.indexOf(asset),
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              "" +
                                                asset.name +
                                                " - " +
                                                _vm._entityPropertyValueByName({
                                                  entityList: _vm.modelList,
                                                  idKey: "id",
                                                  idValue: asset.modelId,
                                                  propertyKey: "name",
                                                }) +
                                                " - " +
                                                _vm._entityPropertyValueByName({
                                                  entityList: _vm.locationList,
                                                  idKey: "id",
                                                  idValue: asset.locationId,
                                                  propertyKey: "name",
                                                })
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectedAssets.splice(
                                            0,
                                            _vm.selectedAssets.length
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear equipment\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.statusIds &&
                          _vm.filters.statusIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Status Filters (" +
                                        _vm._s(_vm.filters.statusIds.length) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.statusIds,
                                    function (assetStatusId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: assetStatusId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.statusIds.splice(
                                                  _vm.filters.statusIds.indexOf(
                                                    assetStatusId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.assetStatusList,
                                                      idKey: "id",
                                                      idValue: assetStatusId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.statusIds.splice(
                                              0,
                                              _vm.filters.statusIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear statuses\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.activityTypeIds &&
                          _vm.filters.activityTypeIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Last Activity Filters (" +
                                        _vm._s(
                                          _vm.filters.activityTypeIds.length
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.activityTypeIds,
                                    function (activityTypeId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: activityTypeId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.activityTypeIds.splice(
                                                  _vm.filters.activityTypeIds.indexOf(
                                                    activityTypeId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.activityTypeList,
                                                      idKey: "id",
                                                      idValue: activityTypeId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.activityTypeIds.splice(
                                              0,
                                              _vm.filters.activityTypeIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear activities\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.modelIds &&
                          _vm.filters.modelIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Model Filters (" +
                                        _vm._s(_vm.filters.modelIds.length) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.modelIds,
                                    function (modelId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: modelId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.modelIds.splice(
                                                  _vm.filters.modelIds.indexOf(
                                                    modelId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList: _vm.modelList,
                                                      idKey: "id",
                                                      idValue: modelId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.modelIds.splice(
                                              0,
                                              _vm.filters.modelIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear models\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.manufacturerIds &&
                          _vm.filters.manufacturerIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Manufacturer Filters (" +
                                        _vm._s(
                                          _vm.filters.manufacturerIds.length
                                        ) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.manufacturerIds,
                                    function (manufacturerId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: manufacturerId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.manufacturerIds.splice(
                                                  _vm.filters.manufacturerIds.indexOf(
                                                    manufacturerId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.manufacturerList,
                                                      idKey: "id",
                                                      idValue: manufacturerId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.manufacturerIds.splice(
                                              0,
                                              _vm.filters.manufacturerIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear manufacturers\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.categoryIds &&
                          _vm.filters.categoryIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Category Filters (" +
                                        _vm._s(_vm.filters.categoryIds.length) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.categoryIds,
                                    function (categoryId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: categoryId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.categoryIds.splice(
                                                  _vm.filters.categoryIds.indexOf(
                                                    categoryId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.categoryList,
                                                      idKey: "id",
                                                      idValue: categoryId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.categoryIds.splice(
                                              0,
                                              _vm.filters.categoryIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear categories\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.locationIds &&
                          _vm.filters.locationIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Location Filters (" +
                                        _vm._s(_vm.filters.locationIds.length) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.locationIds,
                                    function (locationId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: locationId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.locationIds.splice(
                                                  _vm.filters.locationIds.indexOf(
                                                    locationId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.locationList,
                                                      idKey: "id",
                                                      idValue: locationId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.locationIds.splice(
                                              0,
                                              _vm.filters.locationIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear locations\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filters &&
                          _vm.filters.ownerIds &&
                          _vm.filters.ownerIds.length
                            ? _c(
                                "v-flex",
                                [
                                  _c("span", { staticClass: "subheading" }, [
                                    _vm._v(
                                      "Owner Filters (" +
                                        _vm._s(_vm.filters.ownerIds.length) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.filters.ownerIds,
                                    function (ownerId) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: ownerId,
                                          attrs: {
                                            close: "",
                                            disabled: _vm.isLoading,
                                          },
                                          on: {
                                            input: function ($event) {
                                              ;[
                                                _vm.filters.ownerIds.splice(
                                                  _vm.filters.ownerIds.indexOf(
                                                    ownerId
                                                  ),
                                                  1
                                                ),
                                                _vm.fetchAssetList(),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                "" +
                                                  _vm._entityPropertyValueByName(
                                                    {
                                                      entityList:
                                                        _vm.clientList,
                                                      idKey: "id",
                                                      idValue: ownerId,
                                                      propertyKey: "name",
                                                    }
                                                  )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        small: "",
                                        disabled: _vm.isLoading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[
                                            _vm.filters.ownerIds.splice(
                                              0,
                                              _vm.filters.ownerIds.length
                                            ),
                                            _vm.fetchAssetList(),
                                          ]
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            clear owners\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
        model: {
          value: _vm.selectedAssets,
          callback: function ($$v) {
            _vm.selectedAssets = $$v
          },
          expression: "selectedAssets",
        },
      }),
      _vm._v(" "),
      _c("DialogFormAssetAdd", {
        attrs: {
          showDialog: _vm.showDialogFormAssetAdd,
          modelList: _vm.modelList,
          manufacturerList: _vm.manufacturerList,
          categoryList: _vm.categoryList,
          locationList: _vm.locationList,
          clientList: _vm.clientList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormAssetAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormActivityAdd", {
        attrs: {
          showDialog: _vm.showDialogFormActivityAdd,
          selectedAssets: _vm.selectedAssets,
          modelList: _vm.modelList,
          locationList: _vm.locationList,
          clientList: _vm.clientList,
          userList: _vm.userList,
          activityTypeList: _vm.activityTypeList,
          assetStatusList: _vm.assetStatusList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormActivityAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormActivityAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormAssetFilter", {
        attrs: {
          showDialog: _vm.showDialogFormAssetFilter,
          filtersToEdit: _vm.filters,
          modelList: _vm.modelList,
          manufacturerList: _vm.manufacturerList,
          categoryList: _vm.categoryList,
          activityTypeList: _vm.activityTypeList,
          locationList: _vm.locationList,
          clientList: _vm.clientList,
          assetStatusList: _vm.assetStatusList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetFilter = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormAssetFilterSubmit(val),
            (_vm.showDialogFormAssetFilter = false),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }